import React from "react";
import {useHistory} from "react-router-dom";
import {toast} from "react-toastify";
import {Button, Input, LoginBox, LoginContainer, Title} from "./styles";

const LoginSignatures:React.FC = () => {
  const [password, setPassword] = React.useState('');
  const history = useHistory();

  const predefinedPassword = 'vJXC3GcLxcrdF#e8rnAydx';

  const handleLogin = () => {
    if(password === predefinedPassword){
      history.push('/admin/produtos')
    } else {
      toast.error("Senha incorreta!");
    }
  };

  return(
    <LoginContainer>
      <LoginBox>
        <Title>Login Produtos Contratados</Title>
        <Input
          type="password"
          placeholder="Insira a senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button onClick={handleLogin}>Entrar</Button>
      </LoginBox>
    </LoginContainer>
  )
}

export default LoginSignatures;
